import { crudPage } from '../../components/crud-page.js';
import { Subcategories, Categories } from '../../api/resources.js';

export default async function SubcategoriesPage(outlet) {
  // Cargar categorias para el select
  const cats = await Categories.list({ limit: 200 });
  const catOptions = (cats.data || []).map((c) => ({ value: c.id, label: c.name }));

  await crudPage(outlet, {
    title: 'Subcategorias',
    api: Subcategories,
    columns: [
      { key: 'category_name', label: 'Categoria' },
      { key: 'name',          label: 'Nombre' },
      { key: 'code',          label: 'Codigo' },
    ],
    formFields: (item) => [
      { name: 'category_id', label: 'Categoria', type: 'select', options: catOptions, value: item.category_id, required: true },
      { name: 'name', label: 'Nombre', value: item.name, required: true },
      { name: 'code', label: 'Codigo', value: item.code, required: true, pattern: '[A-Z0-9_-]+' },
      { name: 'description', label: 'Descripcion', value: item.description, type: 'textarea', full: true },
    ],
    transformBeforeSave: (data) => ({ ...data, code: data.code?.toUpperCase() }),
  });
}
